import React from 'react';
import PropTypes from 'prop-types';

import Marker from 'components/Marker';
import Map from 'components/Map';

import css from './MapBlock.module.scss';

import icon from './valgt-prosjekt-42x49px.svg';

class MapBlock extends React.Component {
    static propTypes = {
        "address": PropTypes.string.isRequired,
        "location": PropTypes.string.isRequired,
        "zoomLevel": PropTypes.number.isRequired,
        "projectAddressLabel": PropTypes.string,
        "projectStatusLabel": PropTypes.string,
        "projects": PropTypes.arrayOf(PropTypes.shape({
            "location": PropTypes.string.isRequired,
        })),
        "tileLayer": PropTypes.string
    }

    _getProjectName() {
        let name = "Marker";

        if (typeof document !== 'undefined' && document.querySelector) {
            const meta = document.querySelector('meta[property="og:title"]')
            if(meta) {
                name = meta.content;
            }
        }

        return name;
    }

    render() {
        const {
            address,
            location,
            zoomLevel,
            projectAddressLabel,
            projectStatusLabel,
            projects,
            tileLayer
        } = this.props;

        if(! location) return null;

        const center = location.split(',').map(parseFloat);

        return (
            <div className={css.block}>
                <div className={css.map}>
                    <Map
                        center={center}
                        zoomLevel={zoomLevel}
                        style={{
                            position: 'absolute'
                        }}
                        tileLayer={tileLayer}
                    >
                        <Marker
                            marker="project-current"
                            location={location}
                            emphasize={true}
                            title={this._getProjectName()}
                        />
                        {projects && projects.map(p => (
                            <Marker
                                key={p.location}
                                project={{
                                    ...p,
                                    projectStatusLabel,
                                }}
                                location={p.location}
                                title={p.name}
                            />
                        ))}
                    </Map>
                </div>
                <div className={css.address}>
                    <img alt="AF Gruppen" className={css.icon} src={icon} />
                    <p>
                        {projectAddressLabel && (
                            <span className={css.label}>{`${projectAddressLabel}`}</span>
                        )}
                        <span>{address}</span>
                    </p>
                </div>
            </div>
        );
    }
}

export default MapBlock;



// WEBPACK FOOTER //
// ./src/components/MapBlock/MapBlock.jsx